<template>
  <b-container class="rooms-list">
    <b-row>
      <b-col lg="6" offset-lg="3">
        <b-card class="card" no-body header="Mis salas">
          <b-list-group flush>
            <b-list-group-item v-if="myRooms.length === 0">
              No has creado ninguna sala
            </b-list-group-item>
            <router-link v-for="room in myRooms" v-bind:key="room.id" :to="{ name: 'room', params: {roomId: room.id}}">
              <b-list-group-item
                class="d-flex justify-content-between align-items-center">
                {{ room.name }}
                <span>
                  <b-icon icon="lock-fill" v-if="room.private"></b-icon>
                </span>
              </b-list-group-item>
            </router-link>
          </b-list-group>
        </b-card>
        <b-button 
          :class="creationVisible ? null : 'collapsed'"
          class="w-100 create-room-button"
          :aria-expanded="creationVisible ? 'true' : 'false'"
          aria-controls="collapse-1"
          @click="creationVisible = !creationVisible">
          Crea una Nueva Sala
        </b-button>
        <b-collapse id="collapse-1" v-model="creationVisible" class="mt-2">
          <b-card>
            <b-form inline class="d-flex justify-content-between">
              <b-form-group :state="state" :invalid-feedback="invalidFeedback" class="w-100">
                <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                  <b-input v-model="newRoom.name" placeholder="Nueva sala" :state="nameState"></b-input>
                  <b-input v-model="newRoom.password" placeholder="Contraseña" v-if="newRoom.private" :state="passwordState"></b-input>
                </b-input-group>
              </b-form-group>
              <b-form-checkbox v-model="newRoom.private" class="mb-2 mr-sm-2 mb-sm-0">
                Privada
              </b-form-checkbox>
              <b-button variant="primary" @click="createRoom" :disabled="!state">Crear Sala</b-button>
            </b-form>
          </b-card>
        </b-collapse>
        <b-card class="card" no-body header="Salas abiertas">
          <b-list-group flush>
            <b-list-group-item v-if="publicRooms.length === 0">
              No hay ninguna sala abierta
            </b-list-group-item>
            <router-link v-for="room in publicRooms" v-bind:key="room.id" :to="{ name: 'room', params: {roomId: room.id}}">
              <b-list-group-item
                class="d-flex justify-content-between align-items-center">
                {{ room.name }}
                <span v-if="isMine(room.userId)">
                  <b-icon variant="success" icon="person-fill"></b-icon>
                </span>
              </b-list-group-item>
            </router-link>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
const fb = require("../firebaseConfig.js");
export default {
  name: "rooms-list",
  data() {
    return {
      newRoom: {
        name: "",
        private: false,
        password: ""
      },
      myRooms: [],
      publicRooms: [],
      creationVisible: false
    };
  },
  firestore() {
    return {
      myRooms: fb.roomsCollection.where("userId", "==", fb.auth().currentUser.uid),
      publicRooms: fb.roomsCollection.where("private", "==", false),
    };
  },
  computed: {
    state() {
      if (this.newRoom.private) {
        return this.newRoom.name.length >= 3 && this.newRoom.password.length >=3;
      } else {
        return this.newRoom.name.length >= 3;
      }
    },
    nameState() {
      return this.newRoom.name.length >= 3;
    },
    passwordState() {
      return (!this.newRoom.private) || this.newRoom.password.length >=3;
    },
    invalidFeedback() {
      let message = '';
      if (!this.nameState && !this.passwordState) {
        message = "Nombre y contraseña deben tener al menos 3 caracteres";
      } else if (!this.nameState) {
        message = "Nombre debe tener al menos 3 caracteres";
      } else if (!this.passwordState) {
        message = "La contraseña debe tener al menos 3 caracteres";
      }
      return message;
    }
  },
  methods: {
    isMine(userId) {
      return userId === fb.auth().currentUser.uid;
    },
    createRoom: function() {
      if (!this.state) {
        console.warn(this.state)
        return false;
      }
      fb.roomsCollection
        .add({
          userId: fb.auth().currentUser.uid,
          name: this.newRoom.name,
          private: this.newRoom.private,
          password: this.newRoom.password,
          gameIds: [],
          members: [`${fb.auth().currentUser.uid}`]
        })
        .then(ref => {
          ref.update({ id: ref.id });
          this.newRoom = {
            name: '',
            password: '',
            private: false,
            members: []
          };
          this.creationVisible = false;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.card, .create-room-button {
  margin-top: 30px;
}
.rooms-list {
  text-align: center;
  padding-bottom: 40px;
}
</style>